import { Component, OnInit, Input, Output, EventEmitter, Inject, ViewChild } from '@angular/core';
import { FormControl, UntypedFormGroup} from '@angular/forms';
import { orderType } from '@app/_models';
import { FadvIconLibraryService, FadvDatePickerComponent } from '@fa-switch-sharedservices/ng-elements';
import { TooltipMessageService } from '@app/_services/toolservice.service';
import { BirthdayValidator } from '@app/_helpers';

@Component({
  selector: 'app-candidate-details',
  templateUrl: './candidatedetails.component.html',
  styleUrls: ['candidatedetails.component.less'],
})
export class CandidateDetailsComponent implements OnInit {
  @ViewChild('fadvDatePicker') fadvDatePicker!: FadvDatePickerComponent;
  @Output() notifyParentDob: EventEmitter<Date> = new EventEmitter();
  @Output() notifyParentSSN: EventEmitter<String> = new EventEmitter();
  @Input() candidate: UntypedFormGroup;
  @Input() order: string;
  @Input() requireMiddleName: boolean;
  @Input() disableFirstName: boolean;
  @Input() disableLastName: boolean;
  @Input() requireDL: boolean;
  middleNameLabel: string;
  legalNameTooltip: string;
  ssnMessage: string;
  ssnTemp: String;
  dobTemp: Date;
  obfuscatedDate: Date = new Date();
  minimumYear: Date = this.getMinimumDate();
  maximumYear: Date = new Date();
  tooOld: Date = this.getTooOldDate();
  hideDatePicker: Boolean;
  emailInvalid: boolean;
  confirmEmailInvalid: boolean;
  firstNameInvalid: boolean;
  lastNameInvalid: boolean;
  middleNameIvalid: boolean;
  ssnInvalid: boolean;
  dobInvalid: boolean;
  dlNumberInvalid: boolean;
  dlStateInvalid: boolean;

  constructor(
    private tooltipMessenger: TooltipMessageService,
    @Inject(FadvIconLibraryService) iconLibraryService: FadvIconLibraryService) {
      this.tooltipMessenger.currentDisableDobValid.subscribe(hideDatePicker => this.hideDatePicker = hideDatePicker);
  }

  ngOnInit(): void {
    this.emailInvalid = false;
    this.confirmEmailInvalid = false;
    this.firstNameInvalid = false;
    this.lastNameInvalid = false;
    this.middleNameIvalid = false;
    this.ssnInvalid = false;
    this.dobInvalid = false;
    this.dlNumberInvalid = false;
    this.dlStateInvalid = false;

    this.tooltipMessenger.currentNameMessage.subscribe(legalNameTooltip => this.legalNameTooltip = legalNameTooltip);
    this.middleNameLabel = this.order === orderType.online ? "Does your applicant " : "Do you ";
    this.ssnMessage = this.order === orderType.online ? "applicant's" : "";
  }

  handleDob(event: any) {
    if (!isNaN(event.target.value)) {
      this.notifyParentDob.emit(event.target.value);
    }
    this.tooltipMessenger.currentDisableDobValid.subscribe(hideDatePicker => this.hideDatePicker = hideDatePicker);
    this.dobTemp = event.target.value;
    this.handleDobValidity();
  }

  unobstructDob(event: any) {
    this.hideDatePicker = false;
  }

  assignTempValue(event: any) {
    this.fadvDatePicker.value = this.dobTemp;
  }

  obstructDob(event: any){
    this.tooltipMessenger.currentDisableDobValid.subscribe(hideDatePicker => this.hideDatePicker = hideDatePicker);
  }

  getTooOldDate(){
    let currentDate = new Date();
    let goodDate = currentDate.getFullYear() - 150;
    currentDate.setFullYear(goodDate);
    return currentDate;
  }

  getMinimumDate(){
    let currentDate = new Date();
    let goodDate = currentDate.getFullYear() - 16;
    currentDate.setFullYear(goodDate);
    return currentDate;
  }

  handleDobValidity(): void{
    var check = this.candidate.get('dob');
    if(check.hasError)
    {
      this.dobInvalid = true;
    }
    else
    {
      this.dobInvalid = false;
    }
  }

  unobstructSSN(event: any) {
    if (event.target.value.length == 9) {
      event.target.value = this.ssnTemp;
    }
  }

  obstructSSN(event: any){
    var numbers = /^[0-9]+$/;
    if(event.target.value.length == 9 && event.target.value.match(numbers)){
      this.ssnTemp = event.target.value
      this.notifyParentSSN.emit(event.target.value);
      event.target.value = "*********"
    }
  }

  showValidation(field: string){
    if(this.candidate.controls[field].invalid && this.candidate.controls[field].dirty){
        this[field+"Invalid"] = true;
    }
    else{
        this[field+"Invalid"] = false;
    }
}
}
